import PropTypes from 'prop-types';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Typography, Stack, Box, Paper, Button } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';

// ----------------------------------------------------------------------

const RootStyle = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: 20,
  background: theme.palette.primary.lighter,
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  boxShadow: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

// ----------------------------------------------------------------------

YangaVirtualAccount.propTypes = {
  bankName: PropTypes.string,
  accountNumber: PropTypes.string,
};

export default function YangaVirtualAccount({ bankName, accountNumber }) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(accountNumber);
  };

  return (
    <RootStyle>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ 
            width: 40, 
            height: 40, 
            borderRadius: '50%', 
            bgcolor: '#FFF', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: 'primary.main'
        }}>
          <Iconify icon="eva:credit-card-outline" width={20} height={20} />
        </Box>
        <Box>
            <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                {bankName}
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, color: '#111827' }}>
                {accountNumber || 'Generating...'}
            </Typography>
        </Box>
      </Stack>
      
      <Button 
        size="small" 
        onClick={copyToClipboard}
        variant="contained"
        sx={{ 
            borderRadius: '10px',
            px: 2,
            fontWeight: 700,
        }}
      >
        Copy
      </Button>
    </RootStyle>
  );
}
